function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { OAuthService } from './OAuthService'; // adapted from: https://stackoverflow.com/questions/51297206/fetch-api-global-error-handler

var _addAuth = function _addAuth(options) {
  options = options || {};
  options.headers = options.headers || {};
  return new Promise(function (resolve) {
    setTimeout(function () {
      var token = OAuthService.Token;

      if (!token || token === "null") {
        console.warn('[AUTH] No token available when making AJAX request');
        resolve(options);
      } else {
        options.credentials = "include";
        options.withCredentials = true;
        options.headers.Authorization = "Bearer ".concat(token);
        resolve(options);
      }
    }, 50);
  });
};

var _addCSRF = function _addCSRF(options) {
  return new Promise(function (resolve) {
    options = options || {};
    options.headers = options.headers || {};

    if (!!OAuthService.CSRFToken && !!OAuthService.CSRFToken.token && !!OAuthService.CSRFToken.expiresAfterUtc) {
      var expiresAfterUTC = new Date(OAuthService.CSRFToken.expiresAfterUtc);

      var nowUTC = _getCurrentUTCDateTime();

      if (nowUTC >= expiresAfterUTC) {
        OAuthService.SaveCSRFTokenAsync().then(function () {
          options.headers["x-csrf-token"] = OAuthService.CSRFToken.token;
          resolve(options);
        });
      } else {
        options.headers["x-csrf-token"] = OAuthService.CSRFToken.token;
        resolve(options);
      }
    } else {
      resolve(options);
    }
  });
};

var _getCurrentUTCDateTime = function _getCurrentUTCDateTime() {
  var now = new Date();
  var utcDateTime = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());
  return utcDateTime;
};

var _htmlSanitizer = /<\/?(embed|form|frame|frameset|html|iframe|input|keygen|link|meta|noembed|noframes|noscript|object|plaintext|pre|script|select|svg|video|wbr|xmp)[^>]*>/ig;
var _eventSanitizer = /(<[^>]+\s)on[^=]+/ig;

var _htmlSanitize = function _htmlSanitize(textObj) {
  var sanitize = function sanitize(str) {
    return str.replace(_htmlSanitizer, "").replace(_eventSanitizer, "$1 sanitizedEvent");
  };

  var cleanKeys = function cleanKeys(obj, depth) {
    if (!obj) {
      return obj;
    }

    Object.getOwnPropertyNames(obj).forEach(function (key) {
      if (typeof obj[key] === "string") {
        obj[key] = sanitize(obj[key]);
      }

      if (_typeof(obj[key]) === "object" && depth < 40) {
        obj[key] = cleanKeys(obj[key], depth + 1);
      }
    });
    return obj;
  };

  return cleanKeys(textObj, 0);
};

export var Ajax = /*#__PURE__*/function () {
  function Ajax() {
    _classCallCheck(this, Ajax);
  }

  _createClass(Ajax, null, [{
    key: "Get",
    value: function Get(url) {
      return Ajax.RefreshTokensIfNeededAsync().then(function () {
        return _addAuth();
      }).then(function (options) {
        return fetch(url, options);
      }).then(function (response) {
        if (!response.ok) {
          if (response.status === 401) {
            OAuthService.SignIn();
            return Promise.reject(new Error('Authentication required'));
          }

          return Promise.reject(new Error("HTTP error! Status: ".concat(response.status)));
        }

        return response.json();
      }).then(function (json) {
        return _htmlSanitize(json);
      })["catch"](function (error) {
        return Promise.reject(error);
      });
    }
  }, {
    key: "Post",
    value: function () {
      var _Post = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
        var data,
            additionalHeaders,
            retry,
            formData,
            options,
            response,
            json,
            err,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _args.length > 1 && _args[1] !== undefined ? _args[1] : new FormData();
                additionalHeaders = _args.length > 2 ? _args[2] : undefined;
                retry = _args.length > 3 && _args[3] !== undefined ? _args[3] : true;
                _context.next = 5;
                return Ajax.RefreshTokensIfNeededAsync();

              case 5:
                formData = data;
                _context.next = 8;
                return _addAuth({
                  method: "POST",
                  body: formData
                });

              case 8:
                options = _context.sent;

                if (additionalHeaders) {
                  Object.keys(additionalHeaders).forEach(function (header) {
                    options.headers[header] = additionalHeaders[header];
                  });
                }

                _context.next = 12;
                return _addCSRF(options);

              case 12:
                options = _context.sent;
                _context.prev = 13;
                _context.next = 16;
                return fetch(url, options);

              case 16:
                response = _context.sent;

                if (!response.ok) {
                  _context.next = 24;
                  break;
                }

                _context.next = 20;
                return response.json();

              case 20:
                json = _context.sent;
                return _context.abrupt("return", _htmlSanitize(json));

              case 24:
                _context.prev = 24;
                _context.next = 27;
                return response.json();

              case 27:
                err = _context.sent;
                throw err;

              case 31:
                _context.prev = 31;
                _context.t0 = _context["catch"](24);
                throw {
                  StatusCode: response.status,
                  Message: response.statusText,
                  SecondaryStatusCode: null
                };

              case 34:
                _context.next = 46;
                break;

              case 36:
                _context.prev = 36;
                _context.t1 = _context["catch"](13);

                if (!(retry && _context.t1.SecondaryStatusCode && _context.t1.SecondaryStatusCode === "CSRF")) {
                  _context.next = 45;
                  break;
                }

                console.log("[CSRF] Token rejected, refreshing for request to ".concat(url));
                _context.next = 42;
                return OAuthService.SaveCSRFTokenAsync();

              case 42:
                return _context.abrupt("return", this.Post(url, data, additionalHeaders, false));

              case 45:
                throw _context.t1;

              case 46:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[13, 36], [24, 31]]);
      }));

      function Post(_x) {
        return _Post.apply(this, arguments);
      }

      return Post;
    }()
  }, {
    key: "RefreshTokensIfNeededAsync",
    value: function () {
      var _RefreshTokensIfNeededAsync = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var currentTime, expiresAfter;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                currentTime = new Date();
                expiresAfter = OAuthService.ExpiresAfter;

                if (!(!expiresAfter || currentTime > expiresAfter)) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return OAuthService.RefreshTokensAsync();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function RefreshTokensIfNeededAsync() {
        return _RefreshTokensIfNeededAsync.apply(this, arguments);
      }

      return RefreshTokensIfNeededAsync;
    }()
  }]);

  return Ajax;
}();